// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableoem tr td {
  padding-top: 5px !important;
}

.inventory-label {
  font-family: "Omnes-ATT-W02-Medium";
  font-size: 16px;
}

.multistub {
  padding: 3%;
  margin-left: 4%;
}
@media (max-width: 1024px) {
  .multistub {
    margin-top: 100px;
  }
}

@media (max-width: 1024px) {
  .multistub-heading {
    font-size: 22px;
    margin-top: -30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/multi-stubid-page/multi-stubid-page.component.scss"],"names":[],"mappings":"AACI;EACE,2BAAA;AAAN;;AAIE;EACE,mCAAA;EACA,eAAA;AADJ;;AAGG;EACC,WAAA;EACA,eAAA;AAAJ;AACI;EAHD;IAIK,iBAAA;EAEN;AACF;;AACI;EADD;IAEI,eAAA;IACA,iBAAA;EAGL;AACF","sourcesContent":[".tableoem{\n    tr td{\n      padding-top: 5px !important;\n    }\n  \n  }\n  .inventory-label{\n    font-family: 'Omnes-ATT-W02-Medium';\n    font-size: 16px;\n   }\n   .multistub{\n    padding: 3%;\n    margin-left: 4%;\n    @media(max-width: 1024px) {\n        margin-top: 100px;\n   }\n   }\n   .multistub-heading{\n    @media(max-width: 1024px) {\n       font-size: 22px;\n       margin-top: -30px;\n   }\n }\n//  tr:nth-child(odd) {\n//     background-color: #d3d9df;\n// }\n   \n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
